import axiosInstance from '@common/services/axiosIntance/axiosService';
import { AxiosResponse } from 'axios';
import { PaymentIntent } from '@stripe/stripe-js';

type StripeConfigurationResponseItem = {
  publicKey: string;
  clientId: string;
};
type PaymentIntentResponse = {
  id: string;
};
export const useStripePaymentV2 = () => {
  const getStripeConfiguration = async ({
    appId,
  }: {
    appId: string;
  }): Promise<StripeConfigurationResponseItem | null> => {
    const response: AxiosResponse<StripeConfigurationResponseItem> =
      await axiosInstance({
        method: 'GET',
        url: '/stripe-connection/preview/configuration',
        params: {
          appId,
        },
      });
    return response.data || null;
  };
  const stripePayment = async (data: {
    amount: number;
    currency: string;
    emailBuyer: string;
    accountConnectId: string;
    paymentMethodId: string;
    appId: string;
    paymentDescription?: string;
  }): Promise<PaymentIntent | null> => {
    const response: AxiosResponse<PaymentIntent> = await axiosInstance({
      method: 'POST',
      url: '/stripe-connection/payment',
      data,
    });
    return response.data || null;
  };
  const disconnectStripe = async (data: {
    accountConnectId: string;
    appId: string;
  }): Promise<PaymentIntentResponse> => {
    const response: AxiosResponse<{ id: string }> = await axiosInstance({
      method: 'POST',
      url: '/stripe-connection/disconnect',
      data,
    });
    return response.data || null;
  };
  return {
    getStripeConfiguration,
    stripePayment,
    disconnectStripe,
  };
};
